import { render } from "./index.vue?vue&type=template&id=46128b26"
import script from "./partners?vue&type=script&lang=js&external"
export * from "./partners?vue&type=script&lang=js&external"

import "./partners.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__